/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unused-vars */

// Primitive palette here for reference, should not be used directly
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error type
const _primitive = {
	yellow: {
		'50': '#ffffeb',
		'100': '#fffec7',
		'200': '#fff98f',
		'300': '#ffe600',
		'400': '#ffdb00',
		'500': '#e4bd0e',
		'600': '#c59409',
		'700': '#9d6a0b',
		'800': '#825411',
		'900': '#6e4415',
	},
	purple: {
		'50': '#fbf3ff',
		'100': '#f3deff',
		'200': '#e9c1ff',
		'300': '#dfa5ff',
		'400': '#cf75ff',
		'500': '#be46ff',
		'600': '#ab0eff',
		'700': '#8d08d4',
		'800': '#7607b2',
		'900': '#5b038b',
	},
	red: {
		'50': '#fef2f2',
		'100': '#ffe2e1',
		'200': '#ffcbc9',
		'300': '#fea6a3',
		'400': '#fb726e',
		'500': '#f34e49',
		'600': '#e02822',
		'700': '#bc1e19',
		'800': '#9c1c18',
		'900': '#811e1b',
	},
	base: {
		White: '#ffffff',
		Transparent: '#ffffff00',
	},
	blue: {
		'50': '#f0f7ff',
		'100': '#e2efff',
		'200': '#cddbff',
		'300': '#a5b9ff',
		'400': '#708fff',
		'500': '#4771ff',
		'600': '#0d4dfb',
		'700': '#003cd6',
		'800': '#0038bc',
		'900': '#003193',
	},
	green: {
		'50': '#eefff5',
		'100': '#d8ffe8',
		'200': '#b3ffd3',
		'300': '#79fcb0',
		'400': '#49f28f',
		'500': '#0dda62',
		'600': '#04b54e',
		'700': '#078e3f',
		'800': '#0c6f35',
		'900': '#0c5b2d',
	},
	pink: {
		'50': '#fef1f3',
		'100': '#ffe4e9',
		'200': '#ffc9d2',
		'300': '#ff9dad',
		'400': '#ff617b',
		'500': '#ff3254',
		'600': '#f31238',
		'700': '#d40225',
		'800': '#af0521',
		'900': '#910a21',
	},
	gray: {
		slate: {
			'50': '#403a490d',
			'100': '#403a491a',
			'200': '#403a4933',
			'300': '#403a494d',
			'400': '#403a4966',
			'500': '#403a4980',
			'600': '#403a4999',
			'700': '#403a49b2',
			'800': '#403a49cc',
			'900': '#403a49e5',
			'950': '#403a49',
		},
		'slate.solid': {
			'0': '#ffffff',
			'50': '#faf8fd',
			'100': '#f2f1f8',
			'200': '#ede9f3',
			'300': '#e1dde9',
			'400': '#d0cbda',
			'500': '#bdb7c9',
			'600': '#aaa4b6',
			'700': '#918a9d',
			'800': '#766f81',
			'900': '#5e5768',
			'950': '#403a49',
		},
		neutral: {
			dark: {
				'0': '#ffffff',
				'3': '#ffffff08',
				'5': '#ffffff0f',
				'10': '#ffffff1f',
				'30': '#ffffff4d',
				'50': '#ffffff99',
				'70': '#ffffffc7',
			},
			light: {
				'700-25A': '#3a293e40',
				'700-60A': '#3a293ebf',
			},
		},
	},
	orange: {
		'50': '#fffaed',
		'100': '#fff3d4',
		'200': '#ffe3a8',
		'300': '#ffce71',
		'400': '#ffb64d',
		'500': '#fe9311',
		'600': '#ef7707',
		'700': '#c65a08',
		'800': '#9d470f',
		'900': '#7e3b10',
	},
	brand: {
		'50': '#fef2f2',
		'100': '#ffe2e1',
		'200': '#ffcbc9',
		'300': '#fea6a3',
		'400': '#fb726e',
		'500': '#f34e49',
		'600': '#e02822',
		'700': '#bc1e19',
		'800': '#9c1c18',
		'900': '#811e1b',
	},
	interactive: {
		primary: {
			'50': '#ffffeb',
			'100': '#fffec7',
			'200': '#fff98f',
			'300': '#ffe600',
			'400': '#ffdb00',
			'500': '#e4bd0e',
			'600': '#c59409',
			'700': '#9d6a0b',
			'800': '#825411',
			'900': '#6e4415',
		},
		secondary: {
			'50': '#ffffff',
			'100': '#f2f1f8',
			'200': '#ede9f3',
			'300': '#e1dde9',
			'400': '#d0cbda',
			'500': '#bdb7c9',
			'600': '#aaa4b6',
			'700': '#918a9d',
			'800': '#766f81',
			'900': '#5e5768',
			'950': '#403a49',
		},
	},
	warning: {
		'50': '#fffaed',
		'100': '#fff3d4',
		'200': '#ffe3a8',
		'300': '#ffce71',
		'400': '#ffb64d',
		'500': '#fe9311',
		'600': '#ef7707',
		'700': '#c65a08',
		'800': '#9d470f',
		'900': '#7e3b10',
	},
	error: {
		'50': '#fef1f3',
		'100': '#ffe4e9',
		'200': '#ffc9d2',
		'300': '#ff9dad',
		'400': '#ff617b',
		'500': '#ff3254',
		'600': '#f31238',
		'700': '#d40225',
		'800': '#af0521',
		'900': '#910a21',
	},
	accent: {
		primary: {
			'50': '#f0f7ff',
			'100': '#e2efff',
			'200': '#cddbff',
			'300': '#a5b9ff',
			'400': '#708fff',
			'500': '#4771ff',
			'600': '#0d4dfb',
			'700': '#003cd6',
			'800': '#0038bc',
			'900': '#003193',
		},
		secondary: {
			'50': '#fbf3ff',
			'100': '#f3deff',
			'200': '#e9c1ff',
			'300': '#dfa5ff',
			'400': '#cf75ff',
			'500': '#be46ff',
			'600': '#ab0eff',
			'700': '#8d08d4',
			'800': '#7607b2',
			'900': '#5b038b',
		},
	},
	information: {
		'50': '#f0f7ff',
		'100': '#e2efff',
		'200': '#cddbff',
		'300': '#a5b9ff',
		'400': '#708fff',
		'500': '#4771ff',
		'600': '#0d4dfb',
		'700': '#003cd6',
		'800': '#0038bc',
		'900': '#003193',
	},
};

// Light theme palette here for reference, should not be used directly
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error type
const _theme = {
	brand: {
		'50': '#fef2f2',
		'100': '#ffe2e1',
		'200': '#ffcbc9',
		'300': '#fea6a3',
		'400': '#fb726e',
		'500': '#f34e49',
		'600': '#e02822',
		'700': '#bc1e19',
		'800': '#9c1c18',
		'900': '#811e1b',
	},
	interactive: {
		Primary: {
			'50': '#ffffeb',
			'100': '#fffec7',
			'200': '#fff98f',
			'300': '#ffe600',
			'400': '#ffdb00',
			'500': '#e4bd0e',
			'600': '#c59409',
			'700': '#9d6a0b',
			'800': '#825411',
			'900': '#6e4415',
		},
		Secondary: {
			'50': '#ffffff',
			'100': '#f2f1f8',
			'200': '#ede9f3',
			'300': '#e1dde9',
			'400': '#d0cbda',
			'500': '#bdb7c9',
			'600': '#aaa4b6',
			'700': '#918a9d',
			'800': '#766f81',
			'900': '#5e5768',
			'950': '#403a49',
		},
	},
	warning: {
		'50': '#fffaed',
		'100': '#fff3d4',
		'200': '#ffe3a8',
		'300': '#ffce71',
		'400': '#ffb64d',
		'500': '#fe9311',
		'600': '#ef7707',
		'700': '#c65a08',
		'800': '#9d470f',
		'900': '#7e3b10',
	},
	error: {
		'50': '#fef1f3',
		'100': '#ffe4e9',
		'200': '#ffc9d2',
		'300': '#ff9dad',
		'400': '#ff617b',
		'500': '#ff3254',
		'600': '#f31238',
		'700': '#d40225',
		'800': '#af0521',
		'900': '#910a21',
	},
	accent: {
		Primary: {
			'50': '#f0f7ff',
			'100': '#e2efff',
			'200': '#cddbff',
			'300': '#a5b9ff',
			'400': '#708fff',
			'500': '#4771ff',
			'600': '#0d4dfb',
			'700': '#003cd6',
			'800': '#0038bc',
			'900': '#003193',
		},
		Secondary: {
			'50': '#fbf3ff',
			'100': '#f3deff',
			'200': '#e9c1ff',
			'300': '#dfa5ff',
			'400': '#cf75ff',
			'500': '#be46ff',
			'600': '#ab0eff',
			'700': '#8d08d4',
			'800': '#7607b2',
			'900': '#5b038b',
		},
	},
	information: {
		'50': '#f0f7ff',
		'100': '#e2efff',
		'200': '#cddbff',
		'300': '#a5b9ff',
		'400': '#708fff',
		'500': '#4771ff',
		'600': '#0d4dfb',
		'700': '#003cd6',
		'800': '#0038bc',
		'900': '#003193',
	},
};

export const sunriseColors = {
	semantic: {
		typography: {
			strong: '#403a49',
			'strong.fixed': '#403a49',
			weak: '#766f81',
			disabled: '#403a4966',
			brand: '#bc1e19',
			error: '#910a21',
			warning: '#7e3b10',
			success: '#0c5b2d',
			information: '#003193',
			accent: {
				primary: '#003193',
				secondary: '#5b038b',
			},
			interactive: {
				default: '#003cd6',
				hover: '#0038bc',
				pressed: '#0d4dfb',
				visited: '#003cd6',
			},
			inverse: {
				strong: '#ffffff',
				weak: '#faf8fd',
				disabled: '#e1dde9',
			},
		},
		stroke: {
			strong: '#766f81',
			weak: '#918a9d',
			weaker: '#e1dde9',
			hover: '#766f81',
			press: '#5e5768',
			active: '#918a9d',
			disabled: '#e1dde9',
			error: {
				strong: '#910a21',
				weak: '#ff9dad',
			},
			warning: {
				strong: '#fe9311',
				weak: '#ffce71',
				success: {
					default: '#fe9311',
					weak: '#ffce71',
				},
			},
			success: {
				strong: '#0c5b2d',
				weak: '#0dda62',
			},
			brand: {
				weak: '#fea6a3',
				strong: '#e02822',
			},
			info: {
				strong: '#4771ff',
				weak: '#a5b9ff',
			},
			selected: '#4771ff',
			focus: '#4771ff',
			accent: {
				primary: {
					strong: '#4771ff',
					weak: '#a5b9ff',
				},
				secondary: {
					strong: '#be46ff',
					weak: '#dfa5ff',
				},
			},
			inverse: {
				strong: '#ffffff',
				weak: '#ffffff99',
				disabled: '#ffffff4d',
			},
		},
		icon: {
			strong: '#403a49',
			'strong.fixed': '#403a49',
			weak: '#766f81',
			weaker: '#bdb7c9',
			brand: '#bc1e19',
			interactive: '#6e4415',
			disabled: '#bdb7c9',
			error: '#d40225',
			accent: {
				primary: '#4771ff',
				secondary: '#be46ff',
			},
			selected: '#4771ff',
			warning: '#fe9311',
			success: '#078e3f',
			information: '#4771ff',
			inverse: {
				strong: '#ffffff',
				weak: '#faf8fd',
				disabled: '#e1dde9',
			},
		},
		fill: {
			transparent: '#ffffff00',
			strong: '#403a49',
			weak: '#403a49b2',
			weaker: '#403a491a',
			inverse: {
				strong: '#ffffff',
				weak: '#403a490d',
			},
			hover: '#403a490d',
			hovered: {
				weak: '#403a490d',
			},
			press: '#403a491a',
			disabled: '#403a491a',
			interactive: {
				default: '#ffdb00',
				weak: '#fff98f',
			},
			brand: {
				strong: '#f34e49',
				weak: '#fea6a3',
			},
			error: {
				strong: '#ff3254',
				weak: '#ffc9d2',
				weaker: '#fef1f3',
			},
			warning: {
				strong: '#fe9311',
				weak: '#ffe3a8',
				weaker: '#fffaed',
			},
			accent: {
				primary: {
					strong: '#0d4dfb',
					weak: '#cddbff',
					weaker: '#f0f7ff',
				},
				secondary: {
					strong: '#ab0eff',
					weak: '#e9c1ff',
					weaker: '#fbf3ff',
				},
			},
			selected: '#4771ff',
			information: {
				strong: '#4771ff',
				weak: '#cddbff',
				weaker: '#f0f7ff',
			},
			success: {
				strong: '#0dda62',
				weak: '#b3ffd3',
				weaker: '#eefff5',
			},
			overlay: '#3a293ebf',
		},
		background: {
			base: '#ffffff',
			raised: '#faf8fd',
			overlay: '#f2f1f8',
			brand: '#f34e49',
			accent: {
				primary: '#4771ff',
				secondary: '#be46ff',
			},
		},
		shadow: {
			default: '#3a293e40',
		},
	},
};

export const legacyThemeOverrides = {
	'typography-primary': sunriseColors.semantic.typography.strong,
	'typography-secondary': sunriseColors.semantic.typography.weak,
	'typography-disabled': sunriseColors.semantic.typography.disabled,
	'typography-lightPrimary': sunriseColors.semantic.typography.inverse.strong,
	'typography-lightSecondary': sunriseColors.semantic.typography.inverse.weak,
	'typography-lightDisabled': sunriseColors.semantic.typography.inverse.disabled,
};
